// extracted by mini-css-extract-plugin
export default {"suggestedQuestionLink":"common-functions__suggestedQuestionLink___zzZl5"};